/* ======================================================================================================
   ES STICKY CTA — il richiamo all'azione che torna in basso a destra
   ======================================================================================================

   Sulle schede prodotto normali ci pensa Impact: `<product-quick-add>` osserva il modulo d'acquisto e,
   quando scorre via, fa comparire la pastiglia col pulsante «Aggiungi al carrello». Ma quel componente
   pretende un `buy_buttons` — un `<form>` vero — e l'impianto elettrico non ce l'ha: si ordina dal
   configuratore, non dalla scheda. Senza modulo, niente pastiglia.

   Questo elemento fa la stessa cosa guardando un elemento qualunque invece del modulo. La regola è
   identica a quella del tema, di proposito: compare quando il richiamo dentro la pagina è uscito dallo
   schermo verso l'alto, sparisce quando arriva il footer. Anche le classi sono quelle di Impact
   (`.product-quick-add`), così l'aspetto è lo stesso delle altre schede senza una riga di CSS in più.

   ATTRIBUTI
   - trigger: uno o più selettori separati da virgola. Vince il primo che esiste nella pagina. È il
     richiamo "vero", quello nel flusso: finché si vede, la pastiglia non serve.
   - until: cosa fa sparire la pastiglia. Di norma `.footer`.

   SE IL BERSAGLIO NON C'È si passa a una soglia di scorrimento: meglio una pastiglia che compare un po'
   prima del dovuto che un pulsante che non compare mai. Se invece manca l'IntersectionObserver non si fa
   niente e la pastiglia resta nascosta: il richiamo dentro la pagina c'è comunque, non si perde nulla.
   ====================================================================================================== */

(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var VISIBLE = 'is-visible';

  /* Quanto scorrere prima di mostrarla quando non si trova il bersaglio: una schermata e mezzo, che è
     grosso modo dove finisce la scheda prodotto su un telefono. */
  var FALLBACK_RATIO = 1.5;

  function firstMatch(selectors) {
    var list = (selectors || '').split(',');

    for (var i = 0; i < list.length; i++) {
      var selector = list[i].trim();
      if (!selector) continue;

      var found = document.querySelector(selector);
      if (found) return found;
    }

    return null;
  }

  var EsStickyCta = class extends HTMLElement {
    #passed = false;
    #ended = false;
    #observer = null;
    #onScroll = null;

    connectedCallback() {
      this._trigger = firstMatch(this.getAttribute('trigger'));
      this._end = firstMatch(this.getAttribute('until') || '.footer');

      this.#observer = new IntersectionObserver(this._onObserved.bind(this));

      if (this._trigger) {
        this.#observer.observe(this._trigger);
      } else {
        this._watchScroll();
      }

      if (this._end) this.#observer.observe(this._end);
    }

    disconnectedCallback() {
      if (this.#observer) this.#observer.disconnect();
      if (this.#onScroll) window.removeEventListener('scroll', this.#onScroll);
    }

    _onObserved(entries) {
      entries.forEach((entry) => {
        /* «Superato» vuol dire uscito dallo schermo verso l'alto, non semplicemente non visibile: chi
           non ha ancora scrollato fin lì non deve vedersi arrivare la pastiglia da sotto. */
        if (entry.target === this._trigger) {
          this.#passed = entry.boundingClientRect.bottom < 0;
        }

        if (entry.target === this._end) {
          this.#ended = entry.isIntersecting;
        }
      });

      this._render();
    }

    _watchScroll() {
      this.#onScroll = () => {
        this.#passed = window.scrollY > window.innerHeight * FALLBACK_RATIO;
        this._render();
      };

      window.addEventListener('scroll', this.#onScroll, { passive: true });
      this.#onScroll();
    }

    _render() {
      this.classList.toggle(VISIBLE, this.#passed && !this.#ended);
    }
  };

  if (!window.customElements.get('es-sticky-cta')) {
    window.customElements.define('es-sticky-cta', EsStickyCta);
  }
})();
